// extracted by mini-css-extract-plugin
export default {"button":"circle-button_button__VPtVH","icon":"circle-button_icon__SeMdt"};